import { render, staticRenderFns } from "./CommunityCarnivalAsicMiner.vue?vue&type=template&id=70295c82&"
import script from "./CommunityCarnivalAsicMiner.vue?vue&type=script&lang=js&"
export * from "./CommunityCarnivalAsicMiner.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCarnivalAsicMiner.vue?vue&type=style&index=0&id=70295c82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports